import { getFsValueUseCase } from '../get-fs-value/get-fs-value.use-case';

export const isEnabledNewCouponsListEndpointUseCase = async companyId => {
  const fs = await getFsValueUseCase('is_enabled_new_coupons_list_endpoint');
  if (fs === '*') return true;
  return (fs ?? []).includes(parseInt(companyId, 10));
};

export default { isEnabledNewCouponsListEndpointUseCase };
